export const assets = {
  favicon: {
    src: 'favicon.ico',
  },
  img: {
    footer: {},
    header: {
      el: {
        src: 'img/header/el.svg',
      },
      en: {
        src: 'img/header/en.svg',
      },
    },
    home: {
      national: {
        src: 'img/home/national.png',
      },
      european: {
        src: 'img/home/european.png',
      },
      profile: {
        src: 'img/home/profile.png',
      },
      home: {
        src: 'img/home/home.png',
      },
    },
    patient: {
      ep: {
        src: 'img/patient/ep.svg',
      },
      orcd: {
        src: 'img/patient/orcd.svg',
      },
      ps: {
        src: 'img/patient/ps.svg',
      },
      euvac: {
        src: 'img/patient/euvac.svg',
      }
    },
    countries: {
      at: {
        src: 'img/countries/at.jpg',
        code: 'at',
        name: 'Austria'
      },
      be: {
        src: 'img/countries/be.jpg',
        code: 'be',
        name: 'Belgium'
      },
      bg: {
        src: 'img/countries/bg.jpg',
        code: 'bg',
        name: 'Bulgaria'
      },
      cy: {
        src: 'img/countries/cy.jpg',
        code: 'cy',
        name: 'Cyprus'
      },
      cz: {
        src: 'img/countries/cz.jpg',
        code: 'cz',
        name: 'Czech Republic'
      },
      de: {
        src: 'img/countries/de.jpg',
        code: 'de',
        name: 'Germany'
      },
      dk: {
        src: 'img/countries/dk.jpg',
        code: 'dk',
        name: 'Denmark'
      },
      ee: {
        src: 'img/countries/ee.jpg',
        code: 'ee',
        name: 'Estonia'
      },
      es: {
        src: 'img/countries/es.jpg',
        code: 'es',
        name: 'Spain'
      },
      fi: {
        src: 'img/countries/fi.jpg',
        code: 'fi',
        name: 'Finland'
      },
      fr: {
        src: 'img/countries/fr.jpg',
        code: 'fr',
        name: 'France'
      },
      gr: {
        src: 'img/countries/gr.jpg',
        code: 'gr',
        name: 'Greece'
      },
      hr: {
        src: 'img/countries/hr.jpg',
        code: 'hr',
        name: 'Croatia'
      },
      hu: {
        src: 'img/countries/hu.jpg',
        code: 'hu',
        name: 'Hungary'
      },
      ie: {
        src: 'img/countries/ie.jpg',
        code: 'ie',
        name: 'Ireland'
      },
      is: {
        src: 'img/countries/is.jpg',
        code: 'is',
        name: 'Iceland'
      },
      it: {
        src: 'img/countries/it.jpg',
        code: 'it',
        name: 'Italy'
      },
      lt: {
        src: 'img/countries/lt.jpg',
        code: 'lt',
        name: 'Lithuania'
      },
      lu: {
        src: 'img/countries/lu.jpg',
        code: 'lu',
        name: 'Luxembourg'
      },
      lv: {
        src: 'img/countries/lv.jpg',
        code: 'lv',
        name: 'Latvia'
      },
      mt: {
        src: 'img/countries/mt.jpg',
        code: 'mt',
        name: 'Malta'
      },
      nl: {
        src: 'img/countries/nl.jpg',
        code: 'nl',
        name: 'Netherlands'
      },
      pl: {
        src: 'img/countries/pl.jpg',
        code: 'pl',
        name: 'Poland'
      },
      pt: {
        src: 'img/countries/pt.jpg',
        code: 'pt',
        name: 'Portugal'
      },
      ro: {
        src: 'img/countries/ro.jpg',
        code: 'ro',
        name: 'Romania'
      },
      rs: {
        src: 'img/countries/rs.jpg',
        code: 'rs',
        name: 'Serbia'
      },
      se: {
        src: 'img/countries/se.jpg',
        code: 'se',
        name: 'Sweden'
      },
      si: {
        src: 'img/countries/si.jpg',
        code: 'si',
        name: 'Slovenia'
      },
      sk: {
        src: 'img/countries/sk.jpg',
        code: 'sk',
        name: 'Slovakia',
      },
      sw: {
        src: 'img/countries/sw.jpg',
        code: 'sw',
        name: 'Switzerland'
      },
      uk: {
        src: 'img/countries/uk.jpg',
        code: 'uk',
        name: 'United Kingdom'
      }
    }
  },
  healthIcons: {
    png: {

    },
    svg: {
      outline: {
        conditions: {
          allergies: {
            src: 'healthIcons/svg/outline/conditions/allergies.svg',
          },
          nausea: {
            src: 'healthIcons/svg/outline/conditions/nausea.svg',
          },
          chills_fever: {
            src: 'healthIcons/svg/outline/conditions/chills_fever.svg',
          }
        },
        devices: {
          syringe: {
            src: 'healthIcons/svg/outline/devices/syringe.svg',
          },
          surgical_sterilization: {
            src: 'healthIcons/svg/outline/devices/surgical_sterilization.svg',
          },
          defibrillator: {
            src: 'healthIcons/svg/outline/devices/defibrillator.svg',
          },
          hospitalized: {
            src: 'healthIcons/svg/outline/devices/hospitalized.svg',
          },
          wheelchair: {
            src: 'healthIcons/svg/outline/devices/wheelchair.svg',
          },
          blood_pressure_monitor: {
            src: 'healthIcons/svg/outline/devices/blood_pressure_monitor.svg',
          }
        },
        medications: {
          medicines: {
            src: 'healthIcons/svg/outline/medications/medicines.svg',
          }
        },
        people: {
          pregnant: {
            src: 'healthIcons/svg/outline/people/pregnant.svg',
          }
        },
        symbols: {
          poison: {
            src: 'healthIcons/svg/outline/symbols/poison.svg',
          },
          smoking: {
            src: 'healthIcons/svg/outline/symbols/smoking.svg',
          },
          diagnostics: {
            src: 'healthIcons/svg/outline/symbols/diagnostics.svg',
          }
        },
        zoonoses: {
          animal_snake: {
            src: 'healthIcons/svg/outline/zoonoses/animal_snake.svg',
          }
        }
      }
    }
  }
};
